import { useContext, useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Link, Typography } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ProjectContext from "../../contexts/ProjectContext";
import NavButton from '../nav/navbutton'
import {useFetch} from '../../components/auth/useFetch';

export default function NavBar(props) {
    const projectContext = useContext(ProjectContext)

    const { currentForm, setCurrentForm, cameraDataStore, intentsDataStore, setFdlData } = props;
    const [reviewDisabled, setReviewDisabled] = useState(false);
    const [activeForm, setActiveForm] = useState('intents')
    const fetchWithAuth = useFetch()


    //useEffect(()=>{setActiveForm(currentForm)},[currentForm])
    
    const container = {
        display: 'flex',
        position:'sticky',
        top: '0px',
        justifyContent: 'center',
        color: 'white',
        width: '100%',
        zIndex: '100'
    }
    
    const navButtonStyle = {
        height: '40px',
        flexGrow: '1',
        borderRadius: '0px'
    }

    let cameraDataLength = Object.keys(cameraDataStore).length
    let intentsDataLength = Object.keys(intentsDataStore).length

    useEffect(() => {
        if (cameraDataLength === 0 || intentsDataLength === 0 ) {
            setReviewDisabled(true)
        } else {
            setReviewDisabled(false)
        }
    }, [cameraDataLength, intentsDataLength])


    async function CompilePartialFDL(cameraData, intentsData) {
        let fetchDetails = {
            method: "POST",
            body: JSON.stringify({'cameraData': cameraData, 'intentsData': intentsData}),
            headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db   }
        };

        let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlcompilepartial/`, fetchDetails);
        let response = await request.json();
        return response;
    };

    async function finishSection(event) {
        let partialFDL = await CompilePartialFDL(cameraDataStore, intentsDataStore);
        await fetchReviewResult(partialFDL);
        setCurrentForm('review');
    };

    async function fetchReviewResult(partialFDL) {

        let fetchDetails = {
            method: "POST",
            body: JSON.stringify(partialFDL),
            headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db   }
        };

        let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlreview1/`, fetchDetails);
        let response = await request.text();
        setFdlData(response)
    };

    return (
        <div style={container}>
            <NavButton text='Framing Intents' toolTip='Add a framing intent' style={navButtonStyle} currentForm={currentForm} linkedForm={'intents'} onClick={() => setCurrentForm('intents')}>
            </NavButton>

            <NavButton text='Canvases' toolTip='Add a canvas' style={navButtonStyle} currentForm={currentForm} linkedForm={'camera'} onClick={() => setCurrentForm('camera')}>
            </NavButton>

            <NavButton text='Review' toolTip={reviewDisabled ? 'Ensure project contains at least one framing intent and one canvas' : 'Review and finalise your FDL'} style={navButtonStyle}  currentForm={currentForm} linkedForm={'review'} onClick={finishSection} disabled={reviewDisabled}>
            </NavButton>
        </div>
    )
}
